import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axiosAuth from '@/axios-auth';
import axios from 'axios';
import fs, { Stats } from 'fs';
import _ from 'lodash'; //Para ordenamiento de arreglos.
import { push } from 'core-js/fn/array';
import { strictEqual } from 'assert';
// import path from 'path';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        version: '2.0.1',
        appTitle: 'Emisión de Recibos',
        mainLogo: require('@/assets/centenario.png'),
        mainLogoAppBar: require('@/assets/app_bar.png'),

        bWaitCursor: false,
        bFailedLogin: false,
        isAuthenticated: false,
        bInactiveUser: false,
        userName: '', //Nombre del usuario logueado.
        bAdmin: false,
        //authHeader: null,
        idToken: null,
        userID: null,
        //userType: 0, //1 = superadmin, 2 = admin. prepago, 3 = admin. de seguimiento, 4 = encuestado.

        user: null,
        users: null,
        administrators: null,

        bDuplicatedUserError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar a un usuario con un correo previamente registrado.

        userTypes: [],
        selectedUserTypeIndex: -1,

        bServerResponse: false, //Indica si el servidor ya respondió ante un request de borrado de cuestionario.
        events: [],
        selectedEventIndex: -1,
        bSearchNewEvent: false, //Indica a Events.vue que debe buscar la información de un nuevo evento (mediante un watch).
        newEventID: 0,

        event: {
            eventoid: 0,
            numeroEvento: 0,
            fechaRegistro: '',
            usuarioid: 0,
            usuario: '',
            notas: '',
            salonid: 0,
            fechaEvento: '',
            horaInicio: '',
            horaFin: '',
            clienteid: 0,
            cliente: '',
            rfc: '',
            paqueteid: 0,
            costoPersona: 0,
            numPersonas: 0,
            subtotalPaquete: 0,
            ivaPaquete: 0,
            pagos: [],
            servicios: []
        },

        bEventLoaded: false, //Indica si ya se recibió la información del evento seleccionado, para después poder obtener la información relacionada.
        bLoadingEvent: false, //Indica si la información de un evento está siendo cargada, para no dejar cambiarse a ningún otro evento antes de que se reciba toda la información.
        bEventNotDeletedWarning: false, //PENDIENTE...checas si sí se va a usar esta bandera.

        bSearchNewUser: false, //Indica si se debe buscar el índice del usuario que se acaba de registrar.
        bSearchNewPackage: false,
        bSearchNewService: false,

        newUserEmail: '', //Indica el email de un nuevo usuario registrado, para poder seleccionarlo después en la ventana Usuarios.
        selectedUserIndex: -1, //Indice del usuario seleccionado en la ventana Usuarios.
        selectedPackageIndex: -1,
        selectedServiceIndex: -1,

        eventRooms: [],
        selectedEventRoomIndex: -1, //Indice del salón seleccionado en la ventana Salones (a implementar en un futuro).
        bSearchNewEventRoom: false, //Indica si se debe buscar el índice del salón que se acaba de registrar.
        newEventRoomName: '', //Indica el nombre de un nuevo salón registrado, para poder seleccionarlo después en la ventana Salones (a implementar en un futuro).

        services: [],

        eventPackages: [],
        selectedEventPackageIndex: -1, //Indice del paquete seleccionado en la ventana Paquetes (a implementar en un futuro).

        newEventPackageName: '', //Indica el nombre de un nuevo paquete registrado, para poder seleccionarlo después en la ventana Paquetes (a implementar en un futuro).
        eventPayments: [], //Arreglo de pagos del evento seleccionado en la ventana Eventos.
        eventExtras: [], //Arreglo para los conceptos extras del evento seleccionado en la ventana Eventos.

        bInvoiceProcessed: false, //Indica que el servidor ya mandó el recibo procesado.
        iInvoiceWarning: 0, //Indica la causa por la que no se generó un recibo.
        pdfPath: '',
        bShowClientsDlg: false, //Para desplegar el modal para búsqueda de clientes.
        clients: [], //Resultado de la búsqueda de clientes con los parámetros a buscar (rfc y/o nombre).
        client: null, //Cliente seleccionado en la ventana modal para búsqueda de clientes.
        noClientSearchResult: 'Teclee el nombre y/o RFC del cliente a buscar.', //Leyenda a desplegar en la v-data-table si no hay resultados en la búsqueda.

        payments: [], //Resultado de la búsqueda de pagos.
        noPaymentSearchResult: 'Ingrese un intervalo de fechas para la búsqueda de pagos.',

        bExcelProcessed: false, //Indica que el servidor ya mandó el reporte de pagos en Excel.
        excelPath: ''
    },

    mutations: {
        setFailedLogin(state, payload) {
            state.bFailedLogin = payload;
        },
        setInactiveUser(state, payload) {
            state.bInactiveUser = payload;
        },
        authUser(state, userData) {
            //state.authHeader = userData.authHeader;
            state.idToken = userData.idToken;
            state.userID = userData.userID;
        },
        clearAuthData(state) {
            //state.authHeader = null,
            console.log('clearAuthData...');

            state.idToken = null;
            state.userID = null;
            state.isAuthenticated = false;
        },
        setDuplicatedUserError(state, payload) {
            state.bDuplicatedUserError = payload;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUser(state, user) {
            state.user = user;
            state.userName = user.nombre + ' ' + user.appaterno + ' ' + user.apmaterno;

            if (state.user.tipoid === 1) {
                //Super administrador
                state.bAdmin = true;
            } //Usuario encuestador
            else {
                state.bAdmin = false;
            }
        },

        setUserTypes(state, userTypes) {
            state.bWaitCursor = true;
            state.userTypes = userTypes;
            state.bWaitCursor = false;
        },

        setServerResponse(state, bResponse) {
            state.bServerResponse = bResponse;
        },

        setEvents(state, events) {
            state.bWaitCursor = true;
            state.events = events;

            if (state.newEventID !== 0) {
                var i;
                for (i = 0; i < events.length; i++) {
                    if (state.newEventID === events[i].eventoid) {
                        state.selectedEventIndex = i;
                        state.bSearchNewEvent = true;
                    }
                }
                state.newEventID = 0;
            }

            state.bWaitCursor = false;
        },

        setSelectedEventIndex: (state, index) => {
            state.selectedEventIndex = index;
        },

        setSearchNewEvent: (state, search) => {
            state.bSearchNewEvent = search;
        },

        setNewEventID: (state, id) => {
            state.newEventID = id;
        },

        setEventData(state, event) {
            state.event = event;
        },

        setEventPayments(state) {
            state.eventPayments = [];
            var i;
            for (i = 0; i < state.event.pagos.length; i++) {
                var payment = {
                    paymentID: state.event.pagos[i].pagoid,
                    invoiceNumber: state.event.pagos[i].folio,
                    date: state.event.pagos[i].fecha,
                    concept: state.event.pagos[i].concepto,
                    payMethod: state.event.pagos[i].formaPago,
                    subTotal: state.event.pagos[i].subtotal,
                    iva: state.event.pagos[i].iva,
                    total: state.event.pagos[i].total
                };
                state.eventPayments.push(payment);
            }
        },

        setEventLoaded(state, bLoaded) {
            state.bEventLoaded = bLoaded;
        },

        setLoadingEvent(state, bLoading) {
            state.bLoadingEvent = bLoading;
        },
        setEventRooms(state, rooms) {
            state.bWaitCursor = true;
            state.eventRooms = rooms;

            if (state.bSearchNewEventRoom) {
                var i;
                for (i = 0; i < rooms.length; i++) {
                    if (state.newEventRoomName === rooms[i].salon) {
                        state.selectedEventRoomIndex = i;
                        state.bSearchNewEventRoom = false;
                        state.newEventRoomName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setEventPackages(state, packages) {
            state.bWaitCursor = true;
            state.eventPackages = packages;

            for (let i = 0; i < packages.length; i++) {
                if (state.bSearchNewPackage) {
                    if (state.newPackageName === packages[i].paquete) {
                        state.selectedPackageIndex = i;
                        state.bSearchNewPackage = false;
                        state.newPackageName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setSelectedPackageIndex: (state, index) => {
            state.selectedPackageIndex = index;
        },

        setServices(state, services) {
            state.bWaitCursor = true;
            state.services = services;

            for (let i = 0; i < services.length; i++) {
                if (state.bSearchNewService) {
                    if (state.newServiceName === services[i].servicio) {
                        state.selectedServiceIndex = i;
                        state.bSearchNewService = false;
                        state.newServiceName = '';
                    }
                }
            }

            state.bWaitCursor = false;
        },

        setSelectedServiceIndex: (state, index) => {
            state.selectedServiceIndex = index;
        },

        setUsers(state, users) {
            if (state.users !== null) {
                state.users.length = 0;
            }

            state.bWaitCursor = true;
            state.users = users;

            for (let i = 0; i < users.length; i++) {
                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].email) {
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setAdministrators(state, users) {
            if (state.administrators !== null) {
                state.administrators.length = 0;
            }

            state.bWaitCursor = true;
            state.administrators = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].correo) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        addNewUser(state, newUser) {
            state.users.push(newUser);
        },

        addNewAdministrator(state, newUser) {
            state.administrators.push(newUser);
        },

        setSelectedUserIndex: (state, index) => {
            state.selectedUserIndex = index;
        },

        setInvoiceProcessed(state, payload) {
            state.bInvoiceProcessed = payload;
        },

        setInvoiceWarning(state, payload) {
            state.iInvoiceWarning = payload;
        },

        setPdfPath(state, strPath) {
            state.pdfPath = strPath;
        },

        setErrorNoLang(state, payload) {
            state.bErrorNoLang = payload;
        },

        // updateTotals(state) {
        //     //Se recalcula el total pagado y el adeudo:
        //     state.event.pagado = 0;
        //     state.event.adeudo = state.event.totalEvento;
        //     var i;
        //     for (i = 0; i < state.event.pagos.length; i++) {
        //         state.event.pagado += state.event.pagos[i].total;
        //     }
        //     state.event.adeudo -= state.event.pagado;
        // }

        setShowClientsDlg(state, payload) {
            state.bShowClientsDlg = payload;
        },

        setClients(state, clients) {
            state.clients = clients;
        },

        setClient(state, client) {
            state.client = client;
        },

        setNoClientSearchResult(state, label) {
            state.noClientSearchResult = label;
        },

        setPayments(state, payments) {
            state.payments = payments;
        },

        setNoPaymentSearchResult(state, label) {
            state.noPaymentSearchResult = label;
        },

        setExcelProcessed(state, payload) {
            state.bExcelProcessed = payload;
        },

        setExcelPath(state, strPath) {
            state.excelPath = strPath;
        }
    },

    actions: {
        login({ commit, dispatch, state }, authData) {
            state.bWaitCursor = true;

            //Autenticación en Jocoque:
            axiosAuth
                .post('/usuarios/login/', null, {
                    params: {
                        user: authData.email,
                        password: authData.password
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Autenticación OK, res = ', res);

                    var user = res.data;
                    if (user.error === 0) {
                        var idToken = user.token.slice(7);

                        //axios.defaults.headers.common['Authorization'] = user.token;

                        commit('authUser', {
                            //authHeader: user.token,
                            idToken: idToken,
                            userID: user.usuarioid
                        });

                        //console.log("state.idToken = ", state.idToken);
                        //console.log("state.authData = ", state.authHeader);

                        commit('setIsAuthenticated', true);
                        commit('setUser', user);

                        //Carga todas las tablas de configuración:
                        dispatch('fetchAdminConfigData');

                        const now = new Date();
                        const expirationDate = new Date(now.getTime() + res.data.expiresin * 1000); //Con getTime() se obtiene el tiempo en milisegundos
                        console.log('ExpirationDate = ', expirationDate);

                        //localStorage.setItem('authHeader', res.data.token)
                        //localStorage.setItem('token', res.data.idToken);
                        localStorage.setItem('token', idToken);
                        localStorage.setItem('userID', res.data.localId);
                        localStorage.setItem('expirationDate', expirationDate);
                        localStorage.setItem('userEmail', res.data.email);
                        dispatch('setLogoutTimer', res.data.expiresin);

                        state.bWaitCursor = false;
                        //router.push('/');
                        router.push('/').catch(err => {});
                    } else if (user.error === 3) {
                        //Usuario Inactivo...
                        state.bWaitCursor = false;
                        commit('setIsAuthenticated', false);
                        commit('setInactiveUser', true);
                    } //Error en nombre de usuario o password...
                    else {
                        console.log('Error de autenticación #', user.error);
                        state.bWaitCursor = false;
                        //commit('clearAuthData');
                        commit('setIsAuthenticated', false);
                        commit('setFailedLogin', true);
                    }
                })
                .catch(error => {
                    console.log('Error de autenticación #0: ', error);
                    state.bWaitCursor = false;

                    //commit('clearAuthData');
                    commit('setIsAuthenticated', false);
                    commit('setFailedLogin', true);
                });
        },
        updateFailedLogin({ commit }, failedLogin) {
            commit('setFailedLogin', failedLogin);
        },
        updateInactiveUser({ commit }, inactiveUser) {
            commit('setInactiveUser', inactiveUser);
        },
        setLogoutTimer({ commit }, expirationTime) {
            setTimeout(() => {
                console.log('Llamando a clearAuthData desde setLogoutTimer');
                commit('clearAuthData');
                router.replace('/sign-in'); //Aparentemente es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            }, expirationTime * 1000);
        },
        logout({ commit, state }) {
            axios.delete('/sesion/deleteSession/' + state.idToken); //Borra la sesión
            console.log('Llamando a clearAuthData desde logout');
            commit('clearAuthData');
            //localStorage.removeItem('authHeader');
            localStorage.removeItem('token');
            localStorage.removeItem('userID');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('userEmail');
            //router.replace('/sign-in');//Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            router.replace('/sign-in').catch(err => {}); //Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
        },
        tryAutoLogin({ commit, dispatch }) {
            console.log('TryAutoLogin...');
            const token = localStorage.getItem('token');
            if (!token) {
                console.log('No hay token...');
                return;
            }

            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            const now = new Date();

            if (now >= expirationDate) {
                console.log('Time has expired...');
                return;
            }
            const userID = localStorage.getItem('userID');
            this.commit('authUser', {
                //authHeader: authHeader,
                idToken: token,
                userID: userID
            });

            const userEmail = localStorage.getItem('userEmail');
            commit('setIsAuthenticated', true);

            //Carga al usuario logueado:
            dispatch('userAutoLogin', userEmail);

            router.push('/').catch(err => {});
        },
        userAutoLogin({ commit, dispatch, state }, email) {
            if (!state.idToken) {
                return;
            }

            axios
                .get('/usuarios/getByEmail/' + email + '/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de userAutoLogin: ', res);

                    //error 0 = No hay error.
                    if (res.data.error === 1) {
                        console.log('Error. Sesión no válida.');
                        dispatch('logout');
                    } else {
                        const user = res.data;
                        console.log('user = ', user);
                        commit('setUser', user);

                        //Carga todas las tablas de configuración:
                        dispatch('fetchAdminConfigData');
                    }
                })
                .catch(error => {
                    alert('Error en login: ' + error);
                    console.log('Error en login: ', error);
                    dispatch('logout');
                });
        },

        fetchAdminConfigData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }

            dispatch('fetchUserTypes');
            dispatch('fetchEvents');

            dispatch('fetchEventRooms');
            dispatch('fetchEventPackages');
            dispatch('fetchServices');
            dispatch('fetchUsers');
        },

        fetchEventRooms({ dispatch, state }) {
            state.bWaitCursor = true;

            axios
                .get('/salones/getSalones/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchEventRooms, res = ', res);
                    const data = res.data;
                    const rooms = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const room = data[i];
                        rooms.push(room);
                    }
                    state.bWaitCursor = false;
                    dispatch('updateEventRooms', rooms);
                })
                .catch(error => {
                    console.log('Error en FetchEventRooms, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio Pruebas:
            // var salones = [
            //     {
            //         salonid: 1,
            //         salon: 'Centenario I'
            //     },
            //     {
            //         salonid: 2,
            //         salon: 'Centenario II'
            //     },
            //     {
            //         salonid: 3,
            //         salon: 'Violetas'
            //     },
            //     {
            //         salonid: 4,
            //         salon: 'Girasoles'
            //     }
            // ];

            //dispatch('updateEventRooms', salones);
            //Fin pruebas
        },

        updateEventRooms({ commit, state }, rooms) {
            if (!state.idToken) {
                return;
            }
            commit('setEventRooms', rooms);
        },

        fetchEventPackages({ dispatch, state }) {
            state.bWaitCursor = true;

            axios
                .get('/paquetes/getPaquetes/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('fetchEventPackages, res = ', res);
                    const data = res.data;
                    const eventPackages = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const eventPackage = data[i];
                        eventPackages.push(eventPackage);
                    }
                    state.bWaitCursor = false;
                    dispatch('updateEventPackages', eventPackages);
                })
                .catch(error => {
                    console.log('Error en fetchEventPackages, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio Pruebas:
            // var eventPackages = [
            //     {
            //         paqueteid: 1,
            //         paquete: 'Desayuno'
            //     },
            //     {
            //         paqueteid: 2,
            //         paquete: 'Comida'
            //     },
            //     {
            //         paqueteid: 3,
            //         paquete: 'Cena'
            //     }
            // ];

            //dispatch('updateEventPackages', eventPackages);
            //Fin Pruebas
        },

        fetchServices({ dispatch, state }) {
            state.bWaitCursor = true;

            axios
                .get('/servicios/getServicios/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('fetchServices, res = ', res);
                    const data = res.data;
                    const services = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const service = data[i];
                        services.push(service);
                    }
                    state.bWaitCursor = false;
                    dispatch('updateServices', services);
                })
                .catch(error => {
                    console.log('Error en fetchServices, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio Pruebas:
            // var services = [
            //     {
            //         servicioid: 1,
            //         servicio: 'Mantelería francesa'
            //     },
            //     {
            //         servicioid: 2,
            //         servicio: 'Silla Tiffany'
            //     },
            //     {
            //         servicioid: 3,
            //         servicio:
            //             'Hora extra con D.J. por el total de personas que se contrató el evento.'
            //     },
            //     {
            //         servicioid: 4,
            //         servicio: 'Hora extra con D.J. para eventos de 50 a 80 personas.'
            //     },
            //     {
            //         servicioid: 5,
            //         servicio:
            //             'Menú de torna fiesta chilaquiles verde ó rojos con frijoles refritos  y café.'
            //     },
            //     {
            //         servicioid: 6,
            //         servicio: 'Plato base de acero inoxidable'
            //     }
            // ];

            //dispatch('updateServices', services);

            //Fin Pruebas.
        },

        updateEventPackages({ commit, state }, eventPackages) {
            if (!state.idToken) {
                return;
            }
            commit('setEventPackages', eventPackages);
        },

        updateServices({ commit, state }, services) {
            if (!state.idToken) {
                return;
            }
            commit('setServices', services);
        },

        fetchUserTypes({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/tiposUsuario/getTiposUsuario/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchUserTypes, res = ', res);
                    const userTypes = res.data;
                    state.bWaitCursor = false;
                    commit('setUserTypes', userTypes);
                })
                .catch(error => {
                    console.log('Error en fetchUserTypes, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchEvents({ commit, state }) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            //Inicio Pruebas:
            // var events = [
            //     {
            //         eventoid: 4,
            //         numeroEvento: 2596,
            //         fechaEvento: '2021/09/15',
            //         horaInicio: '09:00',
            //         horaFin: '13:00'
            //     },
            //     {
            //         eventoid: 3,
            //         numeroEvento: 2595,
            //         fechaEvento: '2021/09/11',
            //         horaInicio: '18:00',
            //         horaFin: '21:00'
            //     },
            //     {
            //         eventoid: 2,
            //         numeroEvento: 2594,
            //         fechaEvento: '2021/09/10',
            //         horaInicio: '18:00',
            //         horaFin: '21:00'
            //     },
            //     {
            //         eventoid: 1,
            //         numeroEvento: 2593,
            //         fechaEvento: '2021/09/10',
            //         horaInicio: '14:00',
            //         horaFin: '16:00'
            //     }
            // ];

            // state.bWaitCursor = false;
            // commit('setEvents', events);
            //Fin Pruebas.

            axios
                .get('/eventos/getEventos/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('fetchEventos, res = ', res);
                    const events = res.data;
                    console.log('events = ', events);
                    commit('setEvents', events);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en fetchEvents, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateEventLoaded({ commit }, bLoaded) {
            commit('setEventLoaded', bLoaded);
        },

        updateLoadingEvent({ commit }, bLoading) {
            commit('setLoadingEvent', bLoading);
        },

        updateEvent({ commit, state }, event) {
            commit('setEventData', event);
            commit('setEventPayments');
            state.bEventLoaded = true;
            state.bLoadingEvent = false;
        },

        getEventData({ commit, dispatch, state }, eventID) {
            state.bWaitCursor = true;
            state.bLoadingEvent = true;
            state.bEventLoaded = false;

            //Inicio Pruebas:
            // const evento = {
            //     eventoid: 1,
            //     numeroEvento: 2593,
            //     fechaRegistro: '2021-08-10',
            //     usuarioid: 0,
            //     usuario: 'Roberto Paredes',
            //     notas: 'Se contratan 5 mesas extra.',
            //     salonid: 1,
            //     fechaEvento: '202-09-15',
            //     horaInicio: '09:00',
            //     horaFin: '13:00',
            //     clienteid: 1,
            //     cliente: 'Juan Pérez',
            //     rfc: 'ABC800523AH6',
            //     paqueteid: 1,
            //     costoPersona: 1000,
            //     numPersonas: 50,
            //     subtotalPaquete: 50000,
            //     ivaPaquete: 8000,
            //     pagos: [
            //         {
            //             pagoid: 1,
            //             folio: 1234,
            //             fecha: '2021-09-01',
            //             concepto: 'Anticipo',
            //             formaPagoid: 1,
            //             formaPago: 'Efectivo',
            //             subtotal: 10000,
            //             iva: 1600,
            //             total: 11600
            //         },
            //         {
            //             pagoid: 2,
            //             folio: 12408,
            //             fecha: '2021-08-31',
            //             concepto: 'Comida',
            //             formaPagoid: 2,
            //             formaPago: 'Transferencia',
            //             subtotal: 20000,
            //             iva: 3200,
            //             total: 23200
            //         }
            //     ],
            //     servicios: [
            //         {
            //             servicioid: 1,
            //             concepto: 'Mariachis',
            //             costo: 2000,
            //             cantidad: 1,
            //             subtotal: 2000,
            //             iva: 320,
            //             total: 2320
            //         },
            //         {
            //             servicioid: 2,
            //             concepto: 'Flores',
            //             costo: 1000,
            //             cantidad: 2,
            //             subtotal: 2000,
            //             iva: 320,
            //             total: 2320
            //         }
            //     ]
            // };

            // state.bWaitCursor = false;
            // dispatch('updateEvent', evento);

            //Fin Pruebas

            axios
                .get('/eventos/getEventoById/' + eventID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('getEventData, res = ', res);
                    const event = res.data;
                    if (event.eventoid !== 0) {
                        console.log('getEventData, event = ', event);
                        dispatch('updateEvent', event);
                    }

                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getEventData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        savePayment({ state }, paymentInfo) {
            state.bWaitCursor = true;
            console.log('Payment to save: ', paymentInfo);
            const pagoID = paymentInfo.pago.pagoid; //Para identificar si es pago nuevo o editado.
            console.log('pagoID = ', pagoID);
            axios
                .post(
                    '/eventos/guardaPago/' + paymentInfo.eventoID + '/' + state.idToken,
                    paymentInfo.pago
                )
                .then(res => {
                    console.log('SavePayment, res = ', res);
                    const payment = res.data;
                    //Si era una edición, primero se quita el pago original y luego se agrega el pago editado
                    //en la misma posición (si sólo se reemplaza haciendo event.pagos[i] = payment no funciona):
                    if (pagoID !== 0) {
                        var i;
                        for (i = 0; i < state.event.pagos.length; i++) {
                            if (state.event.pagos[i].pagoid === pagoID) {
                                state.event.pagos.splice(i, 1);
                                state.event.pagos.splice(i, 0, payment);
                                break;
                            }
                        }
                    } //Si es un pago nuevo, se inserta el nuevo pago:
                    else {
                        state.event.pagos.unshift(payment);
                    }
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en savePayment, error = ', error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:
            // var pago = paymentInfo.pago;
            // state.event.pagos.unshift(pago);
            // state.bWaitCursor = false;
            //Fin pruebas.
        },

        deletePayment({ commit, state }, paymentID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            axios
                .delete('/eventos/deletePago/' + paymentID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Payment deleted, res = ', res);
                    // if (res.data.pagoBorrado === 1) {
                    //Borra el pago del objeto local:
                    var i;
                    for (i = 0; i < state.event.pagos.length; i++) {
                        if (state.event.pagos[i].pagoid === paymentID) {
                            state.event.pagos.splice(i, 1);
                            break;
                        }
                    }
                    //Recalcula totales y adeudo:
                    //commit('updateTotals');
                    //}
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });

            //Inicio pruebas
            // var i;
            // for (i = 0; i < state.event.pagos.length; i++) {
            //     if (state.event.pagos[i].pagoid === paymentID) {
            //         state.event.pagos.splice(i, 1);
            //         break;
            //     }
            // }
            // state.bWaitCursor = false;
            //Fin pruebas
        },

        updateErrorNoLang({ commit }, bError) {
            commit('setErrorNoLang', bError);
        },

        deleteEvent({ state }, eventID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            axios
                .delete('/eventos/deleteEvento/' + eventID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Event deleted, res = ', res);

                    if (res.data.eventoBorrado === false) {
                        state.bEventNotDeletedWarning = true;
                        state.bServerResponse = true;
                    } else {
                        state.bEventNotDeletedWarning = false;
                        state.bServerResponse = true;
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        updateServerResponse({ commit }, bResponse) {
            commit('setServerResponse', bResponse);
        },

        updateSelectedEventIndex({ commit }, index) {
            commit('setSelectedEventIndex', index);
        },

        updateSearchNewEvent({ commit }, search) {
            commit('setSearchNewEvent', search);
        },

        updateNewEventID({ commit }, id) {
            commit('setNewEventID', id);
        },

        fetchUsers({ commit, state }) {
            //En esta función se obtienen los usuarios administradores, no los de las encuestas.
            state.bWaitCursor = true;

            axios
                .get('/usuarios/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchUsuarios: ', res);
                    const users = res.data;
                    commit('setUsers', users);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchAdministrators({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/usuarios/getAdmin/' + state.idToken, { crossDomain: true })
                .then(res => {
                    const data = res.data;
                    console.log('res de administradores: ', data);
                    const users = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const user = data[i];
                        users.push(user);
                    }
                    state.bWaitCursor = false;
                    console.log('Administrators: ', users);
                    commit('setAdministrators', users);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        setDuplicatedUserError({ commit }, payload) {
            commit('setDuplicatedUserError', payload);
        },

        saveNewUser({ dispatch, state }, newUser) {
            //Checa que no haya un usuario registado con el mismo correo:

            state.bWaitCursor = true;
            console.log('email: ', newUser.email);

            axios
                .get('/usuarios/getByEmail/' + newUser.email + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    const data = res.data;
                    console.log('New User looking for duplicate, res = ', data);
                    if (data.usuarioid === 0) {
                        //No se encontró un usuario con ese correo...
                        //console.log("Todo bien, podemos registrar usuario...");
                        dispatch('storeNewUser', newUser);
                    } //Ya hay un usuario con ese correo...
                    else {
                        dispatch('setDuplicatedUserError', true);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        storeNewUser({ dispatch, state }, newUser) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewUser = true;
            state.newUserEmail = newUser.email;

            console.log('User to save: ', newUser);

            axios
                .post('/usuarios/' + state.idToken, newUser)
                .then(res => {
                    state.bWaitCursor = false;
                    //console.log("res de CreateUser: ", res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },

        editUser({ dispatch, state }, user) {
            state.bWaitCursor = true;

            console.log('user = ', user);

            //Si el objeto user trae password quiere decir que hay que editar el password:
            console.log('user.password = ', user.password);
            if (user.password !== '') {
                //Cambia el password en la tabla de autenticación:
                console.log('Cambiando Password...');

                //Se crea un objeto con el ID y el password:
                const userPasswd = {
                    usuariosid: user.usuarioid,
                    password: user.password
                };

                axios
                    .post(
                        '/usuarios/updateUserPassword/' +
                            userPasswd.usuariosid +
                            '/' +
                            state.idToken,
                        userPasswd
                    )
                    .then(res => {
                        state.bWaitCursor = false;
                    })
                    .catch(error => {
                        console.log(error);
                        state.bWaitCursor = false;
                    });
            }

            //Edición de los datos del usuario:
            const userData = {
                usuarioid: user.usuarioid,
                activo: user.activo,
                email: user.email,
                nombre: user.nombre,
                appaterno: user.appaterno,
                apmaterno: user.apmaterno,
                empresaid: user.empresaid,
                tipoid: user.tipoid,
                cuestionarioid: user.cuestionarioid,
                numLicencias: user.numLicencias
            };
            console.log('user to save: ', userData);
            state.bWaitCursor = true;
            axios
                .post('/usuarios/' + user.usuarioid + '/' + state.idToken, userData)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de Edición de Usuario: ', res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },
        updateSelectedUserIndex({ commit }, index) {
            commit('setSelectedUserIndex', index);
        },

        deleteUser({ dispatch, state }, userID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/usuarios/deleteUser/' + userID + '/0/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateSelectedPackageIndex({ commit }, index) {
            commit('setSelectedPackageIndex', index);
        },

        saveNewPackage({ dispatch, state }, newPackage) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewPackage = true;
            state.newPackageName = newPackage.paquete;

            axios
                .post('/paquetes/addPaquete/' + state.idToken, newPackage)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los paquetes:
                    dispatch('fetchEventPackages');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewPackage = false;
                });
        },

        editPackage({ dispatch, state }, eventPackage) {
            if (!state.idToken) {
                return;
            }
            console.log('Package to save: ', eventPackage);

            state.bWaitCursor = true;
            state.bSearchNewPackage = true;
            state.newPackageName = eventPackage.paquete;

            axios
                .post('/paquetes/modifyPaquete/' + state.idToken, eventPackage)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los paquetes:
                    dispatch('fetchEventPackages');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewPackage = false;
                });
        },

        deletePackage({ dispatch, state }, packageID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/paquetes/deletePaquete/' + packageID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los paquetes:
                    dispatch('fetchEventPackages');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateSelectedServiceIndex({ commit }, index) {
            commit('setSelectedServiceIndex', index);
        },

        saveNewService({ dispatch, state }, newService) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewService = true;
            state.newServiceName = newService.servicio;

            axios
                .post('/servicios/addServicio/' + state.idToken, newService)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los servicios:
                    dispatch('fetchServices');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewService = false;
                });
        },

        editService({ dispatch, state }, service) {
            if (!state.idToken) {
                return;
            }
            console.log('Service to save: ', service);

            state.bWaitCursor = true;
            state.bSearchNewService = true;
            state.newServiceName = service.servicio;

            axios
                .post('/servicios/modifyServicio/' + state.idToken, service)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los servicios:
                    dispatch('fetchEventServices');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewService = false;
                });
        },

        deleteService({ dispatch, state }, serviceID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/servicios/deleteServicio/' + serviceID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los servicios:
                    dispatch('fetchServices');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        saveNewEvent({ dispatch, state }, event) {
            if (!state.idToken) {
                return;
            }
            console.log('Event to save: ', event);

            state.bWaitCursor = true;
            state.bSearchNewEvent = true;

            axios
                .post('/eventos/guardaEvento/' + state.idToken, event)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('SaveNewEvent, res = ', res);

                    //Se guarda el ID del nuevo evento, para poder seleccionarlo después:
                    dispatch('updateNewEventID', res.data.eventoid);

                    //Se vuelve a pedir al servidor todos los eventos:
                    dispatch('fetchEvents');

                    //Se selecciona el evento nuevo:
                    dispatch('getEventData', res.data.eventoid);
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewEvent = false;
                });
        },

        editEvent({ dispatch, state }, event) {
            if (!state.idToken) {
                return;
            }
            console.log('Event to save: ', event);

            state.bWaitCursor = true;
            state.bSearchNewEvent = true;

            axios
                .post('/eventos/modificaEvento/' + state.idToken, event)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('updateEvent, res = ', res);

                    //Se guarda el ID del evento, para poder seleccionarlo después:
                    dispatch('updateNewEventID', res.data.eventoid);

                    //Se vuelve a pedir al servidor todos los eventos:
                    dispatch('fetchEvents');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewEvent = false;
                });
        },

        printPayment({ state }, paymentID) {
            state.bWaitCursor = true;

            axios
                .get('/reciboGenerator/getRecibo/' + paymentID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('printPayment res = ', res);

                    if (res.data !== 0 && res.data !== 1) {
                        state.iInvoiceWarning = 0;
                        state.pdfPath = 'http://recibos.sistemacentenario.com.mx/' + res.data;
                    } else if (res.data === 0) {
                        //Hubo algún error desconocido al tratar de procesar el recibo...
                        console.log('res.data = 0');
                        state.iInvoiceWarning = 1;
                        state.pdfPath = '';
                    }
                    state.bInvoiceProcessed = true;
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        updateInvoiceProcessed({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setInvoiceProcessed', payload);
        },

        updatePdfPath({ commit, state }, strPath) {
            if (!state.idToken) {
                return;
            }
            commit('setPdfPath', strPath);
        },

        updateShowClientsDlg({ commit }, payload) {
            commit('setShowClientsDlg', payload);
        },

        updateClients({ commit }, clients) {
            commit('setClients', clients);
        },

        updateClient({ commit }, client) {
            commit('setClient', client);
        },

        searchClients({ commit, state }, clientToSearch) {
            state.bWaitCursor = true;

            console.log('clientToSearch = ', clientToSearch);
            axios
                .post('/clientes/getCliente/' + state.idToken, clientToSearch)
                .then(res => {
                    console.log('searchClients, res = ', res);
                    const clients = res.data;
                    state.bWaitCursor = false;
                    commit('setClients', clients);
                    if (clients.length === 0) {
                        commit(
                            'setNoClientSearchResult',
                            'No hay clientes registrados con esos parámetros'
                        );
                    }
                })
                .catch(error => {
                    console.log('Error en searchClients, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateNoClientSearchResult({ commit }, label) {
            commit('setNoClientSearchResult', label);
            console.log('updateNoClientSearchResult, ', label);
        },

        editClient({ state }, clientToSave) {
            state.bWaitCursor = true;
            console.log('Client to save: ', clientToSave);
            axios
                .post('/clientes/modificaCliente/' + state.idToken, clientToSave)
                .then(res => {
                    console.log('editClient, res = ', res);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en editClient, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        newClient({ commit, state }, clientToSave) {
            state.bWaitCursor = true;
            console.log('Client to save: ', clientToSave);
            axios
                .post('/clientes/guardaCliente/' + state.idToken, clientToSave)
                .then(res => {
                    console.log('newClient, res = ', res);
                    var newClient = {
                        clienteid: res.data.clienteid,
                        nombre: res.data.nombre,
                        rfc: res.data.rfc
                    };
                    var clients = [];
                    clients.push(newClient);
                    commit('setClients', clients);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en editClient, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updatePayments({ commit, state }, payments) {
            if (!state.idToken) {
                return;
            }
            commit('setPayments', payments);
        },

        searchPayments({ dispatch, state }, searchDates) {
            state.bWaitCursor = true;

            //console.log('searchDates = ', searchDates);
            axios
                .post('/pagos/getPagos/' + state.idToken, searchDates)
                .then(res => {
                    console.log('searchPayments, res = ', res);
                    const payments = res.data;
                    state.bWaitCursor = false;
                    dispatch('updatePayments', payments);
                    if (payments.length === 0) {
                        commit(
                            'setNoPaymentSearchResult',
                            'No hay pagos registrados en esas fechas'
                        );
                    }
                })
                .catch(error => {
                    console.log('Error en searchPayments, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateNoPaymentSearchResult({ commit }, label) {
            commit('setNoPaymentSearchResult', label);
            console.log('updateNoPaymentSearchResult, ', label);
        },

        exportPaymentsToExcel({ state }, paymentsToExport) {
            state.bWaitCursor = true;

            axios
                .post('/pagos/createExcel/' + state.idToken, paymentsToExport)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('ExcelExport res = ', res);

                    if (res.data !== 0) {
                        state.excelPath = 'http://recibos.sistemacentenario.com.mx/' + res.data;
                    } else {
                        state.excelPath = '';
                    }
                    state.bExcelProcessed = true;
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        updateExcelProcessed({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setExcelProcessed', payload);
        },

        updateExcelPath({ commit, state }, strPath) {
            if (!state.idToken) {
                return;
            }
            commit('setExcelPath', strPath);
        }
    },

    getters: {
        version: state => {
            return state.version;
        },
        appTitle: state => {
            return state.appTitle;
        },
        mainLogo: state => {
            return state.mainLogo;
        },
        mainLogoAppBar: state => {
            return state.mainLogoAppBar;
        },
        waitCursor: state => {
            return state.bWaitCursor;
        },
        failedLogin: state => {
            return state.bFailedLogin;
        },
        inactiveUser: state => {
            return state.bInactiveUser;
        },
        isAuthenticated(state) {
            return state.idToken !== null && state.idToken !== undefined;
        },
        duplicatedUserError(state) {
            return state.bDuplicatedUserError;
        },
        user(state) {
            return state.user;
        },
        userName(state) {
            return state.userName;
        },
        loggedUserID(state) {
            return state.userID;
        },

        userType(state) {
            return state.user.tipoid;
        },

        isAdmin(state) {
            return state.bAdmin;
            //return false;
        },

        userTypes(state) {
            return state.userTypes;
        },
        selectedUserTypeIndex: state => {
            return state.selectedUserTypeIndex;
        },
        serverResponse(state) {
            return state.bServerResponse;
        },
        events(state) {
            return state.events;
        },
        event(state) {
            return state.event;
        },
        eventLoaded(state) {
            return state.bEventLoaded;
        },
        loadingEvent(state) {
            return state.bLoadingEvent;
        },
        selectedEventIndex: state => {
            return state.selectedEventIndex;
        },

        eventRooms: state => {
            return state.eventRooms;
        },
        selectedEventRoomIndex: state => {
            return state.selectedEventRoomIndex;
        },
        eventPackages: state => {
            return state.eventPackages;
        },
        selectedPackageIndex: state => {
            return state.selectedPackageIndex;
        },
        services: state => {
            return state.services;
        },
        selectedServiceIndex: state => {
            return state.selectedServiceIndex;
        },
        users(state) {
            return state.users;
        },
        administrators(state) {
            return state.administrators;
        },
        selectedUserIndex: state => {
            return state.selectedUserIndex;
        },
        invoiceProcessed: state => {
            return state.bInvoiceProcessed;
        },
        invoiceWarning: state => {
            return state.iInvoiceWarning;
        },
        pdfPath: state => {
            return state.pdfPath;
        },
        errorNoLang: state => {
            return state.bErrorNoLang;
        },
        eventPayments: state => {
            return state.eventPayments;
        },
        showClientsDlg: state => {
            return state.bShowClientsDlg;
        },
        clients: state => {
            return state.clients;
        },
        client: state => {
            return state.client;
        },
        noClientSearchResult: state => {
            return state.noClientSearchResult;
        },
        payments: state => {
            return state.payments;
        },
        noPaymentSearchResult: state => {
            return state.noPaymentSearchResult;
        },
        excelProcessed: state => {
            return state.bExcelProcessed;
        },
        excelPath: state => {
            return state.excelPath;
        }
    }
});
